import { z } from 'zod';
// Inventory validation schemas
export const createInventorySchema = z.object({
    name: z
        .string()
        .min(1, 'Inventory name is required')
        .max(100, 'Inventory name must be less than 100 characters')
        .trim(),
    description: z
        .string()
        .max(500, 'Description must be less than 500 characters')
        .trim()
        .optional(),
});
export const updateInventorySchema = z.object({
    name: z
        .string()
        .min(1)
        .max(100)
        .trim()
        .optional(),
    description: z
        .string()
        .max(500)
        .trim()
        .optional()
        .nullable(),
});
//# sourceMappingURL=inventory.js.map